import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { redirectToUrl } from 'src/modules/navigation/actions/navigationActions.ts';
import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw-to-do-list.svg';

interface ActionsProps {
    redirectToUrl: typeof redirectToUrl;
}

type Props = ActionsProps & WithTranslation;

const GoalsAndMotivationPlanStepContainer = withTranslation('cbt')((props: Props) => {
    const redirectToProsConsStep = () =>
        props.redirectToUrl(`/programs/uplift/week-2/pros-and-cons-for-your-goals`);

    const redirectToWhatAreYourGoalsStep = () =>
        props.redirectToUrl(`/programs/uplift/week-2/what-are-your-goals`);

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn md={14}>
                    <S.StepHeading small>
                        {props.t('week-2.over-the-next-week.heading')}
                    </S.StepHeading>
                    <S.StepHeading>{props.t('week-2.over-the-next-week.title')}</S.StepHeading>
                    <S.StepDescription small>
                        {props.t('week-2.over-the-next-week.description.1')}
                    </S.StepDescription>
                    <S.PlannedActivitiesHolder>
                        <S.PlannedActivitiesHeading>
                            {props.t('week-2.over-the-next-week.plannedActivities.heading')}
                        </S.PlannedActivitiesHeading>
                        <S.PlannedActivity smallPadding>
                            <S.ActivityContent>
                                <Trans i18nKey="week-2.over-the-next-week.plannedActivities.activities.1">
                                    Identify one or two more goals for the program. You can input
                                    them
                                    <S.StyledLink onClick={redirectToWhatAreYourGoalsStep}>
                                        here
                                    </S.StyledLink>
                                </Trans>
                            </S.ActivityContent>
                        </S.PlannedActivity>
                        <S.PlannedActivity smallPadding>
                            <S.ActivityContent>
                                <Trans i18nKey="week-2.over-the-next-week.plannedActivities.activities.2">
                                    Do a pro-con analysis for those goals
                                    <S.StyledLink onClick={redirectToProsConsStep}>
                                        here
                                    </S.StyledLink>
                                </Trans>
                            </S.ActivityContent>
                        </S.PlannedActivity>
                    </S.PlannedActivitiesHolder>
                </S.ContentColumn>
                <S.ContentColumn md={10}>
                    <S.StepIcon iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepDescription small>
                        {props.t('week-2.over-the-next-week.description.2')}
                    </S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
        </>
    );
});

export const GoalsAndMotivationPlanStep = connect<ActionsProps>(null, { redirectToUrl })(
    GoalsAndMotivationPlanStepContainer,
);
